/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useEffect, useState} from "react";
import {closestCenter, DndContext, useSensor, useSensors,} from "@dnd-kit/core";
import {arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy,} from "@dnd-kit/sortable";
import {createRange} from "./createRange";
import {SortableItem} from "./SortableItem";
import styled from "styled-components";
import {KeyboardSensor, MouseSensor} from "./Sensors";
import {restrictToParentElement, restrictToVerticalAxis} from "@dnd-kit/modifiers";

const initialItems = createRange<{ id: number; value: string }>(
  2,
  (index: any) => ({
    id: index + 1,
    index: index + 1,
    // value: `https://picsum.photos/id/${index}/200/200`,
    value: `/logo192.png`,
  })
);

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  overflow: hidden;
`

function TestDrag(props: any) {
  const [items, setItems] = useState(props?.items ?? []);
  useEffect(() => {
    setItems(props.items ?? [])
  }, [props.items])
  const sensors = useSensors(
    useSensor(MouseSensor),
    // useSensor(SmartPointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  function handleDragEnd(event: any) {
    const {active, over} = event;

    if (active?.id && over?.id && active !== over.id) {
      setItems((items: any) => {
        const oldIndex = items.findIndex((item: any) => item.id === active.id);
        const newIndex = items.findIndex((item: any) => item.id === over.id);

        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }

  const content = (
    <>
      {items.map((v: any) => {
          const disabled = v?.disableDrag
          return (
            <SortableItem disabled={disabled} key={v?.id} id={v?.id} style={{
              display: v?.visible ? 'flex' : 'none',
              flexFlow: 'column',
              flex: v?.noDefaultLayout ? 'none' : 1,
              overflow: 'auto'
            }}>
              {v?.value}
            </SortableItem>
          )
        }
      )}
    </>
  )

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      modifiers={[restrictToVerticalAxis, restrictToParentElement]}
    >
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        <>
          {content}
        </>
      </SortableContext>
    </DndContext>
  );
}

export default TestDrag;